export type Realm = 'account' | 'host';
export type User = { id: string; username: string; nickname: string; email: string | null; hasOtp: boolean; avatar?: string; signature?: string };
export type Intro = { id: string; title: string; body: string; icon: string };
export type Bootstrap = { realm: Realm; csrf: string; user: User | null; intro: Intro[]; serverTime: number; turnstileSitekey?: string;
  accountOrigin: string; hostOrigin: string; development: boolean; mailReady: boolean; hostOtpConfigured?: boolean };
export class ApiError extends Error {
  constructor(message: string, public status: number, public code?: string) { super(message); }
}
export class AccountClient {
  csrf = '';
  constructor(public baseUrl = '') {}
  async request<T = any>(path: string, method = 'GET', body?: unknown): Promise<T> {
    const response = await fetch(`${this.baseUrl}${path}`, { method, credentials: 'include',
      headers: { ...(body === undefined ? {} : { 'content-type': 'application/json' }), ...(method === 'GET' ? {} : { 'x-csrf-token': this.csrf }) },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
    const data = await response.json().catch(() => ({ error: '😣 吾皇，服务器暂时没有回应，恳请吾皇再试一次吧！' }));
    if (!response.ok) throw new ApiError(data.error || '奴才该死！这一步没办成，偏偏也没查出是哪里出了岔子！😭', response.status,data.code);
    return data;
  }
  async bootstrap() { const state = await this.request<Bootstrap>('/api/bootstrap'); this.csrf = state.csrf; return state; }
}
export const dateTime = (timestamp?: number | null) => timestamp ? new Intl.DateTimeFormat('zh-CN', {
  month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
}).format(timestamp) : '还没有使用过';
export const methodName = (value: string) => ({ password: '密码', otp: '动态验证码', passkey: '通行密钥', email: '邮箱验证' }[value] || value);
export function deviceName(agent: string) {
  const os = /iPhone/.test(agent) ? 'iPhone' : /iPad/.test(agent) ? 'iPad' : /Android/.test(agent) ? 'Android' : /Mac/.test(agent) ? 'Mac' : /Windows/.test(agent) ? 'Windows' : '浏览器';
  const browser = /Edg/.test(agent) ? 'Edge' : /Firefox/.test(agent) ? 'Firefox' : /Chrome/.test(agent) ? 'Chrome / Chromium' : /Safari/.test(agent) ? 'Safari' : '';
  return `${os}${browser ? ` · ${browser}` : ''}`;
}
